/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  AICreditThreshold,
  AIUsageInterval,
  BillingCoupon,
  BillingInterval,
  BillingInvoicePreview,
  BillingMeter,
  BillingMeterUsage,
  BillingPortal,
  BillingProduct,
  BillingSwitchAction,
  BillingUpgrade,
  EntityId,
  Organization,
  OrganizationAIUsage,
  UpgradeOrganizationBilling,
} from "./data-contracts";

/**
 * No description
 * @tags billing, internal
 * @name UpgradeOrganizationPlan
 * @summary Upgrade an organization billing plan
 * @request POST:/orgs/{organizationId}/billing
 * @secure
 */

// @ts-ignore
export const upgradeOrganizationPlan: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** The app screen URL to bring the user back to after a successful checkout. */
    successReturnURL?: string;
    /** The app screen URL to bring the user back to after a canceled checkout. */
    cancelReturnURL?: string;
  };
  RequestBody: UpgradeOrganizationBilling;
  RequestHeaders: {};
  ResponseBody: BillingUpgrade;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing",
  method: "post",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name UpdateOrganizationBillingSettings
 * @summary Update organization billing settings
 * @request PATCH:/orgs/{organizationId}/billing/settings
 * @secure
 */

// @ts-ignore
export const updateOrganizationBillingSettings: {
  route: string;
  method: "patch";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    /** Percentage threshold, or null to disable the alert. */
    aiCreditAlertThreshold?: AICreditThreshold;
    /** Whether AI features pause automatically once all AI credits are used, before usage is billed as overage. */
    aiCreditPauseEnabled?: boolean;
  };
  RequestHeaders: {};
  ResponseBody: Organization;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/settings",
  method: "patch",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name GetOrganizationBillingPortal
 * @summary Get the billing portal
 * @request GET:/orgs/{organizationId}/billing/portal
 * @secure
 */

// @ts-ignore
export const getOrganizationBillingPortal: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingPortal;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/portal",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Generates a billing invoice preview for organizations without an active subscription.
 * @tags billing, internal
 * @name PreviewBillingInvoice
 * @summary Preview billing invoice
 * @request GET:/orgs/{organizationId}/billing/preview
 * @secure
 */

// @ts-ignore
export const previewBillingInvoice: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /** The desired billing interval plan */
    interval: BillingInterval;
    /** The desired core plan */
    product: BillingProduct;
    /** The desired amount of members in the organization */
    members?: number;
    /** The desired amount of published premium sites */
    premiumSites?: number;
    /** The desired amount of published ultimate sites */
    ultimateSites?: number;
    /** Coupon or promotion code to apply */
    coupon?: BillingCoupon;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingInvoicePreview & {
    action: BillingSwitchAction | null;
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/preview",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Returns recorded AI usage for an organization. Calendar buckets use UTC; weeks start on Monday. Requires organization administrator permissions.
 * @tags billing
 * @name GetOrganizationAiUsage
 * @summary Get AI credit usage by AI feature and time period
 * @request GET:/orgs/{organizationId}/billing/ai-usage
 * @secure
 */

// @ts-ignore
export const getOrganizationAIUsage: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {
    /**
     * Inclusive start timestamp. Cannot be older than two years from now.
     * @format date-time
     */
    from: string;
    /**
     * Exclusive end timestamp.
     * @format date-time
     */
    to: string;
    /** Calendar interval used to aggregate usage. */
    interval?: AIUsageInterval;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: OrganizationAIUsage;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/ai-usage",
  method: "get",
  streaming: false,
  tags: ["billing"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name EnableOrganizationBillingMeterAddon
 * @summary Enable billing meter addon for an organization
 * @request PUT:/orgs/{organizationId}/billing/meters/{meterName}
 * @secure
 */

// @ts-ignore
export const enableOrganizationBillingMeterAddon: {
  route: string;
  method: "put";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}",
  method: "put",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name DisableOrganizationBillingMeterAddon
 * @summary Disable billing meter addon for an organization
 * @request DELETE:/orgs/{organizationId}/billing/meters/{meterName}
 * @secure
 */

// @ts-ignore
export const disableOrganizationBillingMeterAddon: {
  route: string;
  method: "delete";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 205;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}",
  method: "delete",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags billing, internal
 * @name GetOrganizationBillingMeterUsage
 * @summary Get billing meter usage for an organization
 * @request GET:/orgs/{organizationId}/billing/meters/{meterName}/usage
 * @secure
 */

// @ts-ignore
export const getOrganizationBillingMeterUsage: {
  route: string;
  method: "get";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
    /** Identifier of the billing meter */
    meterName: BillingMeter;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingMeterUsage;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/billing/meters/{meterName}/usage",
  method: "get",
  streaming: false,
  tags: ["billing", "internal"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
